/* layer: properties */
@supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))){*, ::before, ::after, ::backdrop{--un-ease:initial;}}
@property --un-outline-style{syntax:"*";inherits:false;initial-value:solid;}
@property --un-inset-ring-color{syntax:"*";inherits:false;}
@property --un-inset-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000;}
@property --un-inset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000;}
@property --un-inset-shadow-color{syntax:"*";inherits:false;}
@property --un-ring-color{syntax:"*";inherits:false;}
@property --un-ring-inset{syntax:"*";inherits:false;}
@property --un-ring-offset-color{syntax:"*";inherits:false;}
@property --un-ring-offset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000;}
@property --un-ring-offset-width{syntax:"<length>";inherits:false;initial-value:0px;}
@property --un-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000;}
@property --un-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000;}
@property --un-shadow-color{syntax:"*";inherits:false;}
@property --un-ease{syntax:"*";inherits:false;}
@property --un-blur{syntax:"*";inherits:false;}
@property --un-brightness{syntax:"*";inherits:false;}
@property --un-contrast{syntax:"*";inherits:false;}
@property --un-drop-shadow{syntax:"*";inherits:false;}
@property --un-grayscale{syntax:"*";inherits:false;}
@property --un-hue-rotate{syntax:"*";inherits:false;}
@property --un-invert{syntax:"*";inherits:false;}
@property --un-saturate{syntax:"*";inherits:false;}
@property --un-sepia{syntax:"*";inherits:false;}
@property --un-numeric-figure{syntax:"*";inherits:false;}
@property --un-numeric-fraction{syntax:"*";inherits:false;}
@property --un-numeric-spacing{syntax:"*";inherits:false;}
@property --un-ordinal{syntax:"*";inherits:false;}
@property --un-slashed-zero{syntax:"*";inherits:false;}
/* layer: theme */
:root, :host { --default-transition-timingFunction: cubic-bezier(0.4, 0, 0.2, 1); --default-transition-duration: 150ms; --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1); --ease-out: cubic-bezier(0, 0, 0.2, 1); --spacing: 0.25rem; --ease-DEFAULT: cubic-bezier(0.4, 0, 0.2, 1); --font-sans: ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"; --font-mono: ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace; --default-font-family: var(--font-sans); --default-monoFont-family: var(--font-mono); }
/* layer: base */
 *, ::after, ::before, ::backdrop, ::file-selector-button { box-sizing: border-box;  margin: 0;  padding: 0;  border: 0 solid;  }  html, :host { line-height: 1.5;  -webkit-text-size-adjust: 100%;  tab-size: 4;  font-family: var( --default-font-family, ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji' );  font-feature-settings: var(--default-font-featureSettings, normal);  font-variation-settings: var(--default-font-variationSettings, normal);  -webkit-tap-highlight-color: transparent;  }  hr { height: 0;  color: inherit;  border-top-width: 1px;  }  abbr:where([title]) { -webkit-text-decoration: underline dotted; text-decoration: underline dotted; }  h1, h2, h3, h4, h5, h6 { font-size: inherit; font-weight: inherit; }  a { color: inherit; -webkit-text-decoration: inherit; text-decoration: inherit; }  b, strong { font-weight: bolder; }  code, kbd, samp, pre { font-family: var( --default-monoFont-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace );  font-feature-settings: var(--default-monoFont-featureSettings, normal);  font-variation-settings: var(--default-monoFont-variationSettings, normal);  font-size: 1em;  }  small { font-size: 80%; }  sub, sup { font-size: 75%; line-height: 0; position: relative; vertical-align: baseline; } sub { bottom: -0.25em; } sup { top: -0.5em; }  table { text-indent: 0;  border-color: inherit;  border-collapse: collapse;  }  :-moz-focusring { outline: auto; }  progress { vertical-align: baseline; }  summary { display: list-item; }  ol, ul, menu { list-style: none; }  img, svg, video, canvas, audio, iframe, embed, object { display: block;  vertical-align: middle;  }  img, video { max-width: 100%; height: auto; }  button, input, select, optgroup, textarea, ::file-selector-button { font: inherit;  font-feature-settings: inherit;  font-variation-settings: inherit;  letter-spacing: inherit;  color: inherit;  border-radius: 0;  background-color: transparent;  opacity: 1;  }  :where(select:is([multiple], [size])) optgroup { font-weight: bolder; }  :where(select:is([multiple], [size])) optgroup option { padding-inline-start: 20px; }  ::file-selector-button { margin-inline-end: 4px; }  ::placeholder { opacity: 1; }  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px)  { ::placeholder { color: color-mix(in oklab, currentcolor 50%, transparent); } }  textarea { resize: vertical; }  ::-webkit-search-decoration { -webkit-appearance: none; }  ::-webkit-date-and-time-value { min-height: 1lh;  text-align: inherit;  }  ::-webkit-datetime-edit { display: inline-flex; }  ::-webkit-datetime-edit-fields-wrapper { padding: 0; } ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field { padding-block: 0; }  ::-webkit-calendar-picker-indicator { line-height: 1; }  :-moz-ui-invalid { box-shadow: none; }  button, input:where([type='button'], [type='reset'], [type='submit']), ::file-selector-button { appearance: button; }  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button { height: auto; }  [hidden]:where(:not([hidden~='until-found'])) { display: none !important; }
/* layer: preflights */
/* Box sizing rules */
*,
*::before,
*::after {
    box-sizing: border-box;
}

/* Prevent font size inflation */
html {
    -moz-text-size-adjust: none;
    -webkit-text-size-adjust: none;
    text-size-adjust: none;
}

/* Remove default margin in favour of better control in authored CSS */
body,
h1,
h2,
h3,
h4,
p,
figure,
blockquote,
dl,
dd {
    margin-block-start: 0;
}

/* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
ul[role="list"],
ol[role="list"] {
    list-style: none;
}

/* Set core body defaults */
body {
    min-height: 100dvh;
    line-height: 1.5;
}

/* Set shorter line heights on headings and interactive elements */
h1,
h2,
h3,
h4,
button,
input,
label {
    line-height: 1.1;
}

/* Balance text wrapping on headings */
h1,
h2,
h3,
h4 {
    text-wrap: balance;
}

/* A elements that don't have a class get default styles */
a:not([class]) {
    text-decoration-skip-ink: auto;
    color: currentColor;
}

/* Make images easier to work with */
img,
picture {
    max-width: 100%;
    display: block;
}

/* Inherit fonts for inputs and buttons */
input,
button,
textarea,
select {
    font-family: inherit;
    font-size: inherit;
}

/* Make sure textareas without a rows attribute are not tiny */
textarea:not([rows]) {
    min-height: 10em;
}

/* Anything that has been anchored to should have extra scroll margin */
:target {
    scroll-margin-block: 5ex;
}

:root,
:host {
    --font-sans: "Nunito Variable", "Nunito", monospace;
}

html {
    font-family: var(--font-sans);
}

/* layer: properties */
@supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))){*, ::before, ::after, ::backdrop{--un-bg-opacity:100%;--un-border-opacity:100%;--un-ease:initial;--un-placeholder-opacity:100%;--un-ring-opacity:100%;--un-space-y-reverse:initial;--un-text-opacity:100%;--un-translate-x:initial;--un-translate-y:initial;--un-translate-z:initial;}}
@property --un-text-opacity{syntax:"<percentage>";inherits:false;initial-value:100%;}
@property --un-outline-style{syntax:"*";inherits:false;initial-value:solid;}
@property --un-border-opacity{syntax:"<percentage>";inherits:false;initial-value:100%;}
@property --un-bg-opacity{syntax:"<percentage>";inherits:false;initial-value:100%;}
@property --un-ring-opacity{syntax:"<percentage>";inherits:false;initial-value:100%;}
@property --un-inset-ring-color{syntax:"*";inherits:false;}
@property --un-inset-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000;}
@property --un-inset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000;}
@property --un-inset-shadow-color{syntax:"*";inherits:false;}
@property --un-ring-color{syntax:"*";inherits:false;}
@property --un-ring-inset{syntax:"*";inherits:false;}
@property --un-ring-offset-color{syntax:"*";inherits:false;}
@property --un-ring-offset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000;}
@property --un-ring-offset-width{syntax:"<length>";inherits:false;initial-value:0px;}
@property --un-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000;}
@property --un-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000;}
@property --un-shadow-color{syntax:"*";inherits:false;}
@property --un-translate-x{syntax:"*";inherits:false;initial-value:0;}
@property --un-translate-y{syntax:"*";inherits:false;initial-value:0;}
@property --un-translate-z{syntax:"*";inherits:false;initial-value:0;}
@property --un-ease{syntax:"*";inherits:false;}
@property --un-blur{syntax:"*";inherits:false;}
@property --un-brightness{syntax:"*";inherits:false;}
@property --un-contrast{syntax:"*";inherits:false;}
@property --un-drop-shadow{syntax:"*";inherits:false;}
@property --un-grayscale{syntax:"*";inherits:false;}
@property --un-hue-rotate{syntax:"*";inherits:false;}
@property --un-invert{syntax:"*";inherits:false;}
@property --un-saturate{syntax:"*";inherits:false;}
@property --un-sepia{syntax:"*";inherits:false;}
@property --un-placeholder-opacity{syntax:"<percentage>";inherits:false;initial-value:100%;}
@property --un-numeric-figure{syntax:"*";inherits:false;}
@property --un-numeric-fraction{syntax:"*";inherits:false;}
@property --un-numeric-spacing{syntax:"*";inherits:false;}
@property --un-ordinal{syntax:"*";inherits:false;}
@property --un-slashed-zero{syntax:"*";inherits:false;}
@property --un-space-y-reverse{syntax:"*";inherits:false;initial-value:0;}
/* layer: theme */
:root, :host { --spacing: 0.25rem; --default-transition-timingFunction: cubic-bezier(0.4, 0, 0.2, 1); --default-transition-duration: 150ms; --ease-DEFAULT: cubic-bezier(0.4, 0, 0.2, 1); --text-xs-fontSize: 0.75rem; --text-xs-lineHeight: 1rem; --text-sm-fontSize: 0.875rem; --text-sm-lineHeight: 1.25rem; --text-base-fontSize: 1rem; --text-base-lineHeight: 1.5rem; --text-lg-fontSize: 1.125rem; --text-lg-lineHeight: 1.75rem; --text-xl-fontSize: 1.25rem; --text-xl-lineHeight: 1.75rem; --text-2xl-fontSize: 1.5rem; --text-2xl-lineHeight: 2rem; --container-4xl: 56rem; --fontWeight-semibold: 600; --radius-lg: 0.5rem; --fontWeight-medium: 500; --colors-gray-800: oklch(27.8% 0.033 256.848); --colors-white: #fff; --colors-gray-300: oklch(87.2% 0.01 258.338); --colors-gray-700: oklch(37.3% 0.034 259.733); --colors-blue-600: oklch(54.6% 0.245 262.881); --colors-gray-500: oklch(55.1% 0.027 264.364); --colors-blue-500: oklch(62.3% 0.214 259.815); --colors-gray-50: oklch(98.5% 0.002 247.839); --colors-blue-700: oklch(48.8% 0.243 264.376); --fontWeight-bold: 700; --radius-md: 0.375rem; --colors-gray-100: oklch(96.7% 0.003 264.542); --colors-gray-600: oklch(44.6% 0.03 256.802); --colors-gray-400: oklch(70.7% 0.022 261.325); --colors-red-600: oklch(57.7% 0.245 27.325); }
/* layer: preflights */
/* Box sizing rules */
*,
*::before,
*::after {
    box-sizing: border-box;
}

/* Prevent font size inflation */
html {
    -moz-text-size-adjust: none;
    -webkit-text-size-adjust: none;
    text-size-adjust: none;
}

/* Remove default margin in favour of better control in authored CSS */
body,
h1,
h2,
h3,
h4,
p,
figure,
blockquote,
dl,
dd {
    margin-block-start: 0;
}

/* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
ul[role="list"],
ol[role="list"] {
    list-style: none;
}

/* Set core body defaults */
body {
    min-height: 100dvh;
    line-height: 1.5;
}

/* Set shorter line heights on headings and interactive elements */
h1,
h2,
h3,
h4,
button,
input,
label {
    line-height: 1.1;
}

/* Balance text wrapping on headings */
h1,
h2,
h3,
h4 {
    text-wrap: balance;
}

/* A elements that don't have a class get default styles */
a:not([class]) {
    text-decoration-skip-ink: auto;
    color: currentColor;
}

/* Make images easier to work with */
img,
picture {
    max-width: 100%;
    display: block;
}

/* Inherit fonts for inputs and buttons */
input,
button,
textarea,
select {
    font-family: inherit;
    font-size: inherit;
}

/* Make sure textareas without a rows attribute are not tiny */
textarea:not([rows]) {
    min-height: 10em;
}

/* Anything that has been anchored to should have extra scroll margin */
:target {
    scroll-margin-block: 5ex;
}

:root,
:host {
    --font-sans: "Nunito Variable", "Nunito", monospace;
}

html {
    font-family: var(--font-sans);
}

/* layer: shortcuts */
.container{width:100%;}
@media (min-width: 40rem){
.container{max-width:40rem;}
}
@media (min-width: 48rem){
.container{max-width:48rem;}
}
@media (min-width: 64rem){
.container{max-width:64rem;}
}
@media (min-width: 80rem){
.container{max-width:80rem;}
}
@media (min-width: 96rem){
.container{max-width:96rem;}
}
/* layer: default */
.text-2xl{font-size:var(--text-2xl-fontSize);line-height:var(--un-leading, var(--text-2xl-lineHeight));}
.text-base{font-size:var(--text-base-fontSize);line-height:var(--un-leading, var(--text-base-lineHeight));}
.text-lg{font-size:var(--text-lg-fontSize);line-height:var(--un-leading, var(--text-lg-lineHeight));}
.text-sm{font-size:var(--text-sm-fontSize);line-height:var(--un-leading, var(--text-sm-lineHeight));}
.text-xl{font-size:var(--text-xl-fontSize);line-height:var(--un-leading, var(--text-xl-lineHeight));}
.text-xs{font-size:var(--text-xs-fontSize);line-height:var(--un-leading, var(--text-xs-lineHeight));}
.font-size-0\.75em{font-size:0.75em;}
.text-gray-500{color:color-mix(in srgb, var(--colors-gray-500) var(--un-text-opacity), transparent);}
.text-gray-600{color:color-mix(in srgb, var(--colors-gray-600) var(--un-text-opacity), transparent);}
.text-gray-700{color:color-mix(in srgb, var(--colors-gray-700) var(--un-text-opacity), transparent);}
.text-gray-800{color:color-mix(in srgb, var(--colors-gray-800) var(--un-text-opacity), transparent);}
.text-red-600{color:color-mix(in srgb, var(--colors-red-600) var(--un-text-opacity), transparent);}
.text-white{color:color-mix(in srgb, var(--colors-white) var(--un-text-opacity), transparent);}
.font-bold{--un-font-weight:var(--fontWeight-bold);font-weight:var(--fontWeight-bold);}
.font-medium{--un-font-weight:var(--fontWeight-medium);font-weight:var(--fontWeight-medium);}
.font-semibold{--un-font-weight:var(--fontWeight-semibold);font-weight:var(--fontWeight-semibold);}
.tab{-moz-tab-size:4;-o-tab-size:4;tab-size:4;}
.mx-auto{margin-inline:auto;}
.my{margin-block:calc(var(--spacing) * 4);}
.my-6{margin-block:calc(var(--spacing) * 6);}
.mb-2{margin-bottom:calc(var(--spacing) * 2);}
.mb-3{margin-bottom:calc(var(--spacing) * 3);}
.mb-4{margin-bottom:calc(var(--spacing) * 4);}
.mb-8{margin-bottom:calc(var(--spacing) * 8);}
.me{margin-inline-end:calc(var(--spacing) * 4);}
.mt-1{margin-top:calc(var(--spacing) * 1);}
.mt-3{margin-top:calc(var(--spacing) * 3);}
.p-12{padding:calc(var(--spacing) * 12);}
.p-16{padding:calc(var(--spacing) * 16);}
.p-2{padding:calc(var(--spacing) * 2);}
.p-4{padding:calc(var(--spacing) * 4);}
.p-6{padding:calc(var(--spacing) * 6);}
.p-8{padding:calc(var(--spacing) * 8);}
.px,
.px-4{padding-inline:calc(var(--spacing) * 4);}
.px-2{padding-inline:calc(var(--spacing) * 2);}
.px-3{padding-inline:calc(var(--spacing) * 3);}
.px-6{padding-inline:calc(var(--spacing) * 6);}
.py-2{padding-block:calc(var(--spacing) * 2);}
.py-2\.5{padding-block:calc(var(--spacing) * 2.5);}
.pr-8{padding-right:calc(var(--spacing) * 8);}
.pt{padding-top:calc(var(--spacing) * 4);}
.appearance-none{-webkit-appearance:none;appearance:none;}
.outline{outline-style:var(--un-outline-style);outline-width:1px;}
.focus\:outline-none:focus{--un-outline-style:none;outline-style:none;}
.b,
.border{border-width:1px;}
.border-gray-300{border-color:color-mix(in srgb, var(--colors-gray-300) var(--un-border-opacity), transparent);}
.focus\:border-\[var\(--brand-blue\)\]:focus{border-color:color-mix(in oklab, var(--brand-blue) var(--un-border-opacity), transparent);}
.focus\:border-blue-500:focus{border-color:color-mix(in srgb, var(--colors-blue-500) var(--un-border-opacity), transparent);}
.rounded-lg{border-radius:var(--radius-lg);}
.rounded-md{border-radius:var(--radius-md);}
.bg-\[length\:1\.5em_1em\]{background-size:1.5em 1em;}
.bg-blue-500{background-color:color-mix(in srgb, var(--colors-blue-500) var(--un-bg-opacity), transparent);}
.bg-blue-600{background-color:color-mix(in srgb, var(--colors-blue-600) var(--un-bg-opacity), transparent);}
.bg-gray-50{background-color:color-mix(in srgb, var(--colors-gray-50) var(--un-bg-opacity), transparent);}
.bg-white{background-color:color-mix(in srgb, var(--colors-white) var(--un-bg-opacity), transparent);}
.hover\:bg-blue-700:hover{background-color:color-mix(in srgb, var(--colors-blue-700) var(--un-bg-opacity), transparent);}
.hover\:bg-gray-50:hover{background-color:color-mix(in srgb, var(--colors-gray-50) var(--un-bg-opacity), transparent);}
.disabled\:bg-gray-100:disabled{background-color:color-mix(in srgb, var(--colors-gray-100) var(--un-bg-opacity), transparent);}
.underline{text-decoration-line:underline;}
.flex,
.layout{display:flex;}
.inline-flex{display:inline-flex;}
.flex-1{flex:1 1 0%;}
.grow,
.stretch{flex-grow:1;}
.flex-col,
.vertical{flex-direction:column;}
.flex-wrap{flex-wrap:wrap;}
.gap-0\.5{gap:calc(var(--spacing) * 0.5);}
.gap-2{gap:calc(var(--spacing) * 2);}
.gap-3{gap:calc(var(--spacing) * 3);}
.gap-4{gap:calc(var(--spacing) * 4);}
.gap-6{gap:calc(var(--spacing) * 6);}
.h-4{height:calc(var(--spacing) * 4);}
.max-w-\[50rem\]{max-width:50rem;}
.max-w-4xl{max-width:var(--container-4xl);}
.w-4{width:calc(var(--spacing) * 4);}
.w-full{width:100%;}
.contents{display:contents;}
.visible{visibility:visible;}
.collapse{visibility:collapse;}
.cursor-default{cursor:default;}
.cursor-pointer{cursor:pointer;}
.disabled\:cursor-not-allowed:disabled{cursor:not-allowed;}
.pointer-events-none{pointer-events:none;}
.resize{resize:both;}
.select-none{-webkit-user-select:none;user-select:none;}
.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
.ring{--un-ring-shadow:var(--un-ring-inset,) 0 0 0 calc(1px + var(--un-ring-offset-width)) var(--un-ring-color, currentColor);box-shadow:var(--un-inset-shadow), var(--un-inset-ring-shadow), var(--un-ring-offset-shadow), var(--un-ring-shadow), var(--un-shadow);}
.focus\:ring-2:focus{--un-ring-shadow:var(--un-ring-inset,) 0 0 0 calc(2px + var(--un-ring-offset-width)) var(--un-ring-color, currentColor);box-shadow:var(--un-inset-shadow), var(--un-inset-ring-shadow), var(--un-ring-offset-shadow), var(--un-ring-shadow), var(--un-shadow);}
.focus\:ring-blue-500:focus{--un-ring-color:color-mix(in srgb, var(--colors-blue-500) var(--un-ring-opacity), transparent);}
.focus\:ring-gray-500:focus{--un-ring-color:color-mix(in srgb, var(--colors-gray-500) var(--un-ring-opacity), transparent);}
.focus\:ring-opacity-50:focus{--un-ring-opacity:50%;}
.focus\:ring-offset-2:focus{--un-ring-offset-width:2px;--un-ring-offset-shadow:var(--un-ring-inset,) 0 0 0 var(--un-ring-offset-width) var(--un-ring-offset-color);}
.shadow,
.shadow-sm{--un-shadow:0 1px 3px 0 var(--un-shadow-color, rgb(0 0 0 / 0.1)),0 1px 2px -1px var(--un-shadow-color, rgb(0 0 0 / 0.1));box-shadow:var(--un-inset-shadow), var(--un-inset-ring-shadow), var(--un-ring-offset-shadow), var(--un-ring-shadow), var(--un-shadow);}
.-translate-y-1\/2{--un-translate-y:-50%;translate:var(--un-translate-x) var(--un-translate-y);}
.transform{transform:var(--un-rotate-x) var(--un-rotate-y) var(--un-rotate-z) var(--un-skew-x) var(--un-skew-y);}
.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,--un-gradient-from,--un-gradient-via,--un-gradient-to,opacity,box-shadow,transform,translate,scale,rotate,filter,-webkit-backdrop-filter,backdrop-filter;transition-timing-function:var(--un-ease, var(--default-transition-timingFunction));transition-duration:var(--un-duration, var(--default-transition-duration));}
.transition-all{transition-property:all;transition-timing-function:var(--un-ease, var(--default-transition-timingFunction));transition-duration:var(--un-duration, var(--default-transition-duration));}
.transition-colors{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,--un-gradient-from,--un-gradient-via,--un-gradient-to;transition-timing-function:var(--un-ease, var(--default-transition-timingFunction));transition-duration:var(--un-duration, var(--default-transition-duration));}
.duration-200{--un-duration:200ms;transition-duration:200ms;}
.ease{--un-ease:var(--ease-DEFAULT);transition-timing-function:var(--ease-DEFAULT);}
.items-start{align-items:flex-start;}
.items-end{align-items:flex-end;}
.items-center{align-items:center;}
.bottom-0{bottom:calc(var(--spacing) * 0);}
.right-2{right:calc(var(--spacing) * 2);}
.top-1\/2{top:50%;}
.justify-end{justify-content:flex-end;}
.justify-center{justify-content:center;}
.fixed{position:fixed;}
.sticky{position:sticky;}
.static{position:static;}
.z1{z-index:1;}
.bg-right{background-position:right;}
.bg-no-repeat{background-repeat:no-repeat;}
.blur{--un-blur:blur(8px);filter:var(--un-blur,) var(--un-brightness,) var(--un-contrast,) var(--un-grayscale,) var(--un-hue-rotate,) var(--un-invert,) var(--un-saturate,) var(--un-sepia,) var(--un-drop-shadow,);}
.filter{filter:var(--un-blur,) var(--un-brightness,) var(--un-contrast,) var(--un-grayscale,) var(--un-hue-rotate,) var(--un-invert,) var(--un-saturate,) var(--un-sepia,) var(--un-drop-shadow,);}
.placeholder-gray-400::placeholder{color:color-mix(in srgb, var(--colors-gray-400) var(--un-placeholder-opacity), transparent);}
.table{display:table;}
.border-collapse{border-collapse:collapse;}
.tabular-nums{--un-numeric-spacing:tabular-nums;font-variant-numeric:var(--un-ordinal,) var(--un-slashed-zero,) var(--un-numeric-figure,) var(--un-numeric-spacing,) var(--un-numeric-fraction,);}
.view-transition-name{view-transition-name:name;}
.tiny{font-size:var(--font-size-tiny);}
.tinier{font-size:var(--font-size-tinier);}
.small{font-size:var(--font-size-small);}
.smaller{font-size:var(--font-size-smaller);}
.medium{font-size:var(--font-size-medium);}
.default{font-size:var(--font-size-default);}
.large{font-size:var(--font-size-large);}
.enormous{font-size:var(--font-size-enormous);}
.huge{font-size:var(--font-size-huge);}
.light{font-weight:300 !important;}
.bold{font-weight:bold !important;}
.uppercase{text-transform:uppercase;letter-spacing:0.1em;}
.nowrap{white-space:nowrap;}
.rounded{border-radius:0.5em;}
.border-bottom{border-bottom:solid 1px var(--shade-2);}
.inline{display:inline;}
.inline-block{display:inline-block;}
.block{display:block;}
.relative{position:relative;}
.absolute{position:absolute;}
.horizontal{flex-direction:row;}
.grid{display:grid;grid-template-columns:repeat(auto-fit, minmax(var(--grid-column-width, 10em), 1fr));grid-gap:var(--grid-gap);}
.spacing{--grid-gap:var(--spacing);}
.padded{padding:var(--spacing);}
.fit{max-width:100%;max-height:100%;box-sizing:border-box;}
.fill{min-width:100%;min-height:100%;box-sizing:border-box;}
.hidden{display:none !important;}
.break-all{word-break:break-all;}
.red{--color-highlight:var(--red);--color-highlight-bg:var(--red-bg);}
.orange{--color-highlight:var(--orange);--color-highlight-bg:var(--orange-bg);}
.green{--color-highlight:var(--green);--color-highlight-bg:var(--green-bg);}
.teal{--color-highlight:var(--teal);--color-highlight-bg:var(--teal-bg);}
.blue{--color-highlight:var(--blue);--color-highlight-bg:var(--blue-bg);}
.violet{--color-highlight:var(--violet);--color-highlight-bg:var(--violet-bg);}
.pink{--color-highlight:var(--pink);--color-highlight-bg:var(--pink-bg);}
.grey{--color-highlight:var(--grey);--color-highlight-bg:var(--grey-bg);}
.white{--color-highlight:var(--white);--color-highlight-bg:var(--shade-5);}
.background{background:var(--color-bg);}
.message{color:var(--color-highlight, rgba(0, 0, 0, 0.5));border-radius:var(--border-radius);background:var(--color-highlight-bg, var(--shade-1));border:solid 1px;padding:0.8em 1em;position:relative;margin:1em;}
.box{color:var(--color-highlight);border-radius:0.5em;border:solid 1px var(--color-highlight, var(--shade-2));position:relative;overflow:hidden;}
.space-y-4{
:where(&>:not(:last-child)){--un-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing) * 4) * var(--un-space-y-reverse));margin-block-end:calc(calc(var(--spacing) * 4) * calc(1 - var(--un-space-y-reverse)));}
}
@supports (color: color-mix(in lab, red, red)){
.text-gray-500{color:color-mix(in oklab, var(--colors-gray-500) var(--un-text-opacity), transparent);}
.text-gray-600{color:color-mix(in oklab, var(--colors-gray-600) var(--un-text-opacity), transparent);}
.text-gray-700{color:color-mix(in oklab, var(--colors-gray-700) var(--un-text-opacity), transparent);}
.text-gray-800{color:color-mix(in oklab, var(--colors-gray-800) var(--un-text-opacity), transparent);}
.text-red-600{color:color-mix(in oklab, var(--colors-red-600) var(--un-text-opacity), transparent);}
.text-white{color:color-mix(in oklab, var(--colors-white) var(--un-text-opacity), transparent);}
.border-gray-300{border-color:color-mix(in oklab, var(--colors-gray-300) var(--un-border-opacity), transparent);}
.focus\:border-blue-500:focus{border-color:color-mix(in oklab, var(--colors-blue-500) var(--un-border-opacity), transparent);}
.bg-blue-500{background-color:color-mix(in oklab, var(--colors-blue-500) var(--un-bg-opacity), transparent);}
.bg-blue-600{background-color:color-mix(in oklab, var(--colors-blue-600) var(--un-bg-opacity), transparent);}
.bg-gray-50{background-color:color-mix(in oklab, var(--colors-gray-50) var(--un-bg-opacity), transparent);}
.bg-white{background-color:color-mix(in oklab, var(--colors-white) var(--un-bg-opacity), transparent);}
.hover\:bg-blue-700:hover{background-color:color-mix(in oklab, var(--colors-blue-700) var(--un-bg-opacity), transparent);}
.hover\:bg-gray-50:hover{background-color:color-mix(in oklab, var(--colors-gray-50) var(--un-bg-opacity), transparent);}
.disabled\:bg-gray-100:disabled{background-color:color-mix(in oklab, var(--colors-gray-100) var(--un-bg-opacity), transparent);}
.focus\:ring-blue-500:focus{--un-ring-color:color-mix(in oklab, var(--colors-blue-500) var(--un-ring-opacity), transparent);}
.focus\:ring-gray-500:focus{--un-ring-color:color-mix(in oklab, var(--colors-gray-500) var(--un-ring-opacity), transparent);}
.placeholder-gray-400::placeholder{color:color-mix(in oklab, var(--colors-gray-400) var(--un-placeholder-opacity), transparent);}
}
/* layer: shortcuts */
.container{width:100%;}
.focus-container:focus{width:100%;}
@media (min-width: 40rem){
.container{max-width:40rem;}
.focus-container:focus{max-width:40rem;}
}
@media (min-width: 48rem){
.container{max-width:48rem;}
.focus-container:focus{max-width:48rem;}
}
@media (min-width: 64rem){
.container{max-width:64rem;}
.focus-container:focus{max-width:64rem;}
}
@media (min-width: 80rem){
.container{max-width:80rem;}
.focus-container:focus{max-width:80rem;}
}
@media (min-width: 96rem){
.container{max-width:96rem;}
.focus-container:focus{max-width:96rem;}
}
/* layer: default */
.tab{-moz-tab-size:4;-o-tab-size:4;tab-size:4;}
.ms{margin-inline-start:calc(var(--spacing) * 4);}
.px{padding-inline:calc(var(--spacing) * 4);}
.outline{outline-style:var(--un-outline-style);outline-width:1px;}
.b,
.border{border-width:1px;}
.\@container{container-type:inline-size;}
.underline{text-decoration-line:underline;}
.flex,
.layout{display:flex;}
.inline-flex{display:inline-flex;}
.flex-shrink{flex-shrink:1;}
.flex-grow,
.stretch{flex-grow:1;}
.flex-wrap,
.wrapping{flex-wrap:wrap;}
.gap-2{gap:calc(var(--spacing) * 2);}
.h1{height:calc(var(--spacing) * 1);}
.h2{height:calc(var(--spacing) * 2);}
.h3{height:calc(var(--spacing) * 3);}
.h4{height:calc(var(--spacing) * 4);}
.h5{height:calc(var(--spacing) * 5);}
.contents{display:contents;}
.visible{visibility:visible;}
.collapse{visibility:collapse;}
.resize{resize:both;}
.italic{font-style:italic;}
.shadow,
.shadowChildren\){--un-shadow:0 1px 3px 0 var(--un-shadow-color, rgb(0 0 0 / 0.1)),0 1px 2px -1px var(--un-shadow-color, rgb(0 0 0 / 0.1));box-shadow:var(--un-inset-shadow), var(--un-inset-ring-shadow), var(--un-ring-offset-shadow), var(--un-ring-shadow), var(--un-shadow);}
.transform{transform:var(--un-rotate-x) var(--un-rotate-y) var(--un-rotate-z) var(--un-skew-x) var(--un-skew-y);}
.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,--un-gradient-from,--un-gradient-via,--un-gradient-to,opacity,box-shadow,transform,translate,scale,rotate,filter,-webkit-backdrop-filter,backdrop-filter;transition-timing-function:var(--un-ease, var(--default-transition-timingFunction));transition-duration:var(--un-duration, var(--default-transition-duration));}
.ease{--un-ease:var(--ease-DEFAULT);transition-timing-function:var(--ease-DEFAULT);}
.ease-in-out{--un-ease:var(--ease-in-out);transition-timing-function:var(--ease-in-out);}
.ease-out{--un-ease:var(--ease-out);transition-timing-function:var(--ease-out);}
.fixed{position:fixed;}
.sticky{position:sticky;}
.static{position:static;}
.isolate{isolation:isolate;}
.blur{--un-blur:blur(8px);filter:var(--un-blur,) var(--un-brightness,) var(--un-contrast,) var(--un-grayscale,) var(--un-hue-rotate,) var(--un-invert,) var(--un-saturate,) var(--un-sepia,) var(--un-drop-shadow,);}
.filter{filter:var(--un-blur,) var(--un-brightness,) var(--un-contrast,) var(--un-grayscale,) var(--un-hue-rotate,) var(--un-invert,) var(--un-saturate,) var(--un-sepia,) var(--un-drop-shadow,);}
.table{display:table;}
.border-collapse{border-collapse:collapse;}
.lining-nums{--un-numeric-figure:lining-nums;font-variant-numeric:var(--un-ordinal,) var(--un-slashed-zero,) var(--un-numeric-figure,) var(--un-numeric-spacing,) var(--un-numeric-fraction,);}
.tabular-nums{--un-numeric-spacing:tabular-nums;font-variant-numeric:var(--un-ordinal,) var(--un-slashed-zero,) var(--un-numeric-figure,) var(--un-numeric-spacing,) var(--un-numeric-fraction,);}
.tiny{font-size:var(--font-size-tiny);}
.tinier{font-size:var(--font-size-tinier);}
.small{font-size:var(--font-size-small);}
.smaller{font-size:var(--font-size-smaller);}
.medium{font-size:var(--font-size-medium);}
.mediumer{font-size:var(--font-size-mediumer);}
.default{font-size:var(--font-size-default);}
.large{font-size:var(--font-size-large);}
.larger{font-size:var(--font-size-larger);}
.big{font-size:var(--font-size-big);}
.bigger{font-size:var(--font-size-bigger);}
.massive{font-size:var(--font-size-massive);}
.enormous{font-size:var(--font-size-enormous);}
.huge{font-size:var(--font-size-huge);}
.light,
.thin{font-weight:300 !important;}
.bold{font-weight:bold !important;}
.semibold{font-weight:600 !important;}
.all-small-caps *,
.small-caps{font-variant:small-caps;letter-spacing:0.1em;}
.uppercase{text-transform:uppercase;letter-spacing:0.1em;}
.line-through{text-decoration:line-through;}
.underlined{text-decoration:underline;}
.nowrap{white-space:nowrap;}
.subtle{opacity:0.75;}
.faded{opacity:0.5;}
.rounded{border-radius:0.5em;}
.padded-full{padding:1em;}
.padded-medium{padding:0.7em;}
.border-top{border-top:solid 1px var(--shade-2);}
.border-bottom{border-bottom:solid 1px var(--shade-2);}
.border-left{border-left:solid 1px var(--shade-2);}
.border-right{border-right:solid 1px var(--shade-2);}
.inline{display:inline;}
.inline-block{display:inline-block;}
.block{display:block;}
.relative{position:relative;}
.absolute{position:absolute;}
.text-centering{text-align:center;}
.text-left-aligning{text-align:left;}
.horizontal{flex-direction:row;}
.vertical{flex-direction:column;}
.center-aligning{align-items:center;}
.start-aligning{align-items:flex-start;}
.center-justifying{justify-content:center;}
.centering{align-items:center;justify-content:center;}
.grid{display:grid;grid-template-columns:repeat(auto-fit, minmax(var(--grid-column-width, 10em), 1fr));grid-gap:var(--grid-gap);}
.spacing{--grid-gap:var(--spacing);}
.padded{padding:var(--spacing);}
.horizontally-padded{padding-left:var(--spacing);padding-right:var(--spacing);}
.bottom-padded{padding-bottom:var(--spacing);}
.top-padded{padding-top:var(--spacing);}
.double-padded{padding:calc(2 * var(--spacing));}
.half-padded{padding:calc(0.5 * var(--spacing));}
.margined{margin:var(--spacing);}
.negatively-margined{margin:calc(-1 * var(--spacing));}
.vertically-margined{margin-top:var(--spacing);margin-bottom:var(--spacing);}
.horizontally-margined{margin-left:var(--spacing);margin-right:var(--spacing);}
.right-margined{margin-right:var(--spacing);}
.left-margined{margin-left:var(--spacing);}
.bottom-margined{margin-bottom:var(--spacing);}
.top-margined{margin-top:var(--spacing);}
.double-margined{margin:calc(2 * var(--spacing));}
.fit{max-width:100%;max-height:100%;box-sizing:border-box;}
.fit-vertically{max-height:100%;box-sizing:border-box;}
.fill{min-width:100%;min-height:100%;box-sizing:border-box;}
.fill-horizontally{min-width:100%;box-sizing:border-box;}
.hidden{display:none !important;}
.invisible{opacity:0;transform:scale(0);pointer-events:none;}
.non-interactive{pointer-events:none;}
.break-all{word-break:break-all;}
.red{--color-highlight:var(--red);--color-highlight-bg:var(--red-bg);}
.orange{--color-highlight:var(--orange);--color-highlight-bg:var(--orange-bg);}
.green{--color-highlight:var(--green);--color-highlight-bg:var(--green-bg);}
.blue{--color-highlight:var(--blue);--color-highlight-bg:var(--blue-bg);}
.purple{--color-highlight:var(--purple);--color-highlight-bg:var(--purple-bg);}
.black{--color-highlight:var(--black);--color-highlight-bg:var(--black-bg);}
.white{--color-highlight:var(--white);--color-highlight-bg:var(--shade-5);}
.colored-text{color:var(--color-highlight);}
.background{background:var(--color-bg);}
.spin{animation:spin linear 1s infinite;}
.blink{animation:blink 1.3s alternate infinite;}
.rumble{animation:rumble 300ms;}
.\!message{color:var(--color-highlight, rgba(0, 0, 0, 0.5)) !important;border-radius:var(--border-radius) !important;background:var(--color-highlight-bg, var(--shade-1)) !important;border:solid 1px !important;padding:0.8em 1em !important;position:relative !important;margin:1em !important;}
.message{color:var(--color-highlight, rgba(0, 0, 0, 0.5));border-radius:var(--border-radius);background:var(--color-highlight-bg, var(--shade-1));border:solid 1px;padding:0.8em 1em;position:relative;margin:1em;}
.box{color:var(--color-highlight);border-radius:0.5em;border:solid 1px var(--color-highlight, var(--shade-2));position:relative;overflow:hidden;}